import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M19.5 0q1.86 0 3.18 1.32T24 4.5v15q0 1.86-1.32 3.18T19.5 24h-2.937v-9.297h3.109l.469-3.625h-3.578V8.766q0-.876.367-1.313.366-.437 1.43-.437L20.265 7V3.766q-.985-.141-2.782-.141-2.125 0-3.398 1.25t-1.274 3.531v2.672H9.689v3.625h3.124V24H4.5q-1.86 0-3.18-1.32T0 19.5v-15q0-1.86 1.32-3.18T4.5 0z"
    }, null, -1)
  ])))
}
export default { render: render }